import { FC, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { InvoiceType } from '__generated__/GQL';
import * as Form from 'components/_core/form';
import Skeleton from 'components/Skeleton';
import { FiscalIdFormSchema } from 'features/Work/form/fiscalIdForm.schema';

import locales from './locales';

interface InputProps {
  fiscalId: string;
  lastFiscalId?: string;
  loading: boolean;
  type: InvoiceType;
}

const Input: FC<InputProps> = ({
  fiscalId: defaultFiscalId,
  lastFiscalId,
  loading,
  type,
}) => {
  const { control, setValue } = useFormContext<FiscalIdFormSchema>();

  useEffect(() => {
    // The default fiscalId is defined once the query is resolved but the form is mounted before
    if (defaultFiscalId) {
      setValue('fiscalId', defaultFiscalId, { shouldValidate: true });
    }
  }, [defaultFiscalId, setValue]);

  const hint = lastFiscalId
    ? locales.formatString(locales[type].hint, lastFiscalId)
    : '';

  return (
    <Skeleton isLoaded={!loading}>
      <Controller
        control={control}
        name="fiscalId"
        render={({ field, fieldState }) => (
          <Form.Field
            error={fieldState.error?.message}
            hint={hint}
            label={locales[type].label}
          >
            <Form.Input onChange={field.onChange} value={field.value} />
          </Form.Field>
        )}
      />
    </Skeleton>
  );
};

export default Input;
